/* eslint-disable no-unused-vars */


// export const useOrganizationContext = () => useContext(OrganizationContext);
/* eslint-disable react-hooks/exhaustive-deps */

import { createContext, useContext, useEffect, useState, useMemo } from "react";
import useAPIHandler from "../hook/use-api-handler";


const OrganizationContext = createContext(null);

export function OrganizationContextProvider({ children }) {
  const { fetchData } = useAPIHandler();
  const [stateList, setStateList] = useState([]);
  const [orgConfigationDetails, setConfigationOrgDetails] = useState({});



  // Fetch organization config and state list, but avoid unnecessary re-fetches
  useEffect(() => {


    // Only fetch the state list once
    if (stateList.length === 0) {
      fetchData({ url: "/common/state" }).then((res) => {
        setStateList(
          res?.data?.map((it) => ({
            ...it,
            id: it.state_id,
            name: it.state_name,
          }))
        );
      });
    }
  }, [orgConfigationDetails, stateList, fetchData]);

  // Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(() => ({
    stateList,
    setStateList,
    orgConfigationDetails,
  }), [stateList, orgConfigationDetails]); // Only re-memoize when stateList or orgConfigationDetails change

  return (
    <OrganizationContext.Provider value={value}>{children}</OrganizationContext.Provider>
  );
}

export const useOrganizationContext = () => useContext(OrganizationContext);
